import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'edit-icon',
  templateUrl: './edit-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EditIconComponent {}
